//候选人信息 替换真实信息
export const AllInfo = {
    baseInfo: {
        name: '李庆发',
        subject: '本科',
        sex: "男",
        major: "软件工程",
        age: '21',
        date: '2021-11-11',
        work: '北京',
    },
    info: [
        {
            name: "学历",
            value: "本科"
        },
        {
            name: "毕业院校",
            value: "北京师范大学"
        },
        {
            name: "专业",
            value: "软件工程"
        },
        {
            name: "手机号码",
            value: "13532284043"
        },
        {
            name: "邮箱",
            value: "liqingfa@qq.com"
        }
    ],
    personalTable: [
        {
            name: "逻辑思维",
            score: 4,
            content: "对事物进行比较、分析、概括、判断、推理的能力"
        },
        {
            name: "数字推理",
            score: 5,
            content: "通过计算或推测一列数据的运算关系得到数列中的某项数字的能力"
        },
        {
            name: "数字运算",
            score: 6,
            content: "工作中数字的敏感性以及用数字进行一定程度运算的能力"
        },
        {
            name: "言语理解",
            score: 2.1,
            content: "通过阅读书面文字获得文字中的含义或信息"
        },
        {
            name: "图形推理",
            score: 4.4,
            content: "根据已有的图形，总结规律，推导下一个图形的能力"
        },
        {
            name: "类比推理",
            score: 5.5,
            content: "判断两个事物之间的属性关系，推出两个事物属性关系结论的推理能力"
        },
        {
            name: "定义判断",
            score: 10,
            content: "对概念及该概念的运用标准的定义进行判断的能力"
        },
        {
            name: "机械推理",
            score: 8.6,
            content: "对物体的基本运动规律，机械原理的理解与判断能力"
        },
        {
            name: "材料分析",
            score: 7,
            content: "对统计图等资料进行分析理解，并掌握其中关键信息的能力"
        },
    ],
    heartTable: [
        {
            name: "工作倦怠",
            describe: "身体状态基本良好，大部分时间精力充沛。偶尔感到疲倦或不舒适的症状。但持续时间不长，加以调整后能够恢复良好的状态。",
            score: 4,
            level2: [{
                name: "身体状态",
                score: 4
            },
            {
                name: "精力充沛",
                score: 6
            }
        ]
        },
        {
            name: "情绪稳定",
            describe: "情绪状态基本良好，大部分时间精力充沛。偶尔感到疲倦或不舒适的症状。身体状态基本良好，大部分时间精力充沛。偶尔感到疲倦或不舒适的症状。但持续时间不长，加以调整后能够恢复良好的状态。",
            score: 4,
            level2: [
                {
                    name: "情绪稳定性",
                    score: 9
                },
                {
                    name: "抑郁程度",
                    score: 4
                },
                {
                    name: "焦虑程度",
                    score: 7
                },
            ]
        },
        {
            name: "积极心理",
            describe: "与大多数人一样，懂得调节自己的心态，情绪状态基本良好，大部分时间精力充沛。偶尔感到疲倦或不舒适的症状。与大多数人一样，懂得调节自己的心态，情绪状态基本良好，大部分时间精力充沛。偶尔感到疲倦或不舒适的症状。",
            score: 4,
            level2: [
                {
                    name: "乐观积极",
                    score: 4
                },
                {
                    name: "进取性",
                    score: 7
                },
                {
                    name: "自信心",
                    score: 7
                },
                {
                    name: "持之以恒",
                    score: 7
                },
            ]
        },
        {
            name: "心理症状",
            describe: "情绪状态基本良好，大部分时间精力充沛。偶尔感到疲倦或不舒适的症状。",
            score: 4,
            level2: [
                {
                    name: "偏执性",
                    score: 4
                },
                {
                    name: "精神状态",
                    score: 7
                },

            ]
        },
        {
            name: "人际和谐",
            describe: "情绪状态基本良好，大部分时间精力充沛。偶尔感到疲倦或不舒适的症状。",
            score: 4,
            level2: [
                {
                    name: "亲切随和",
                    score: 4
                },
                {
                    name: "合群性",
                    score: 7
                },
                {
                    name: "外向性",
                    score: 7
                },

            ]
        },
        {
            name: "适应耐挫",
            describe: "情绪状态基本良好，大部分时间精力充沛。偶尔感到疲倦或不舒适的症状。",
            score: 4,
            level2: [
                {
                    name: "社会适应",
                    score: 4
                },
                {
                    name: "应对方式",
                    score: 7
                },
                {
                    name: "忍耐挫折",
                    score: 7
                },

            ]
        },

    ],

    RenTable: [
        {
            name: "服从性",
            score: 8,
            content: "服从、崇拜强势领导，对他人的指导依赖过强，非常愿意在其他人的帮助下完成任务，当意见发生分歧或冲突时，直抒己见的几率较低，容易隐藏个人见解而服从大多数的看法"
        },
        {
            name: "工作调整能力",
            score: 5,
            content: "服从、崇拜强势领导，对他人的指导依赖过强，非常愿意在其他人的帮助下完成任务，当意见发生分歧或冲突时，直抒己见的几率较低，容易隐藏个人见解而服从大多数的看法"
        },
        {
            name: "领导能力",
            score: 6,
            content: "服从、崇拜强势领导，对他人的指导依赖过强，非常愿意在其他人的帮助下完成任务，当意见发生分歧或冲突时，直抒己见的几率较低，容易隐藏个人见解而服从大多数的看法"
        },
        {
            name: "情绪稳定",
            score: 2.1,
            content: "服从、崇拜强势领导，对他人的指导依赖过强，非常愿意在其他人的帮助下完成任务，当意见发生分歧或冲突时，直抒己见的几率较低，容易隐藏个人见解而服从大多数的看法"
        },
        {
            name: "社交能力",
            score: 4.4,
            content: "服从、崇拜强势领导，对他人的指导依赖过强，非常愿意在其他人的帮助下完成任务，当意见发生分歧或冲突时，直抒己见的几率较低，容易隐藏个人见解而服从大多数的看法"
        },
        {
            name: "生活步调",
            score: 5.5,
            content: "服从、崇拜强势领导，对他人的指导依赖过强，非常愿意在其他人的帮助下完成任务，当意见发生分歧或冲突时，直抒己见的几率较低，容易隐藏个人见解而服从大多数的看法"
        },
        {
            name: "输出精力",
            score: 10,
            content: "服从、崇拜强势领导，对他人的指导依赖过强，非常愿意在其他人的帮助下完成任务，当意见发生分歧或冲突时，直抒己见的几率较低，容易隐藏个人见解而服从大多数的看法"
        },

    ],
    advice: [
        {
            title: "认知能力",
            describe: ["有没有遇到这样的情况，当面对一个问题没有办法的时候，你能帮大家理清思路。找到问题的解决办法，具体谈谈当时情况 ", "我们在学习或者工作中面对的问题总是纷繁复杂。"]
        },
        {
            title: "服从性",
            describe: ["有没有遇到这样的情况，当面对一个问题没有办法的时候，你能帮大家理清思路。找到问题的解决办法，具体谈谈当时情况 ", "我们在学习或者工作中面对的问题总是纷繁复杂。"]
        },
        {
            title: "工作调整能力",
            describe: ["有没有遇到这样的情况，当面对一个问题没有办法的时候，你能帮大家理清思路。找到问题的解决办法，具体谈谈当时情况 ", "我们在学习或者工作中面对的问题总是纷繁复杂。"]
        },
        {
            title: "领导能力",
            describe: ["有没有遇到这样的情况，当面对一个问题没有办法的时候，你能帮大家理清思路。找到问题的解决办法，具体谈谈当时情况 ", "我们在学习或者工作中面对的问题总是纷繁复杂。"]
        },
        {
            title: "情绪稳定",
            describe: ["有没有遇到这样的情况，当面对一个问题没有办法的时候，你能帮大家理清思路。找到问题的解决办法，具体谈谈当时情况 ", "我们在学习或者工作中面对的问题总是纷繁复杂。"]
        },
        {
            title: "社交能力",
            describe: ["有没有遇到这样的情况，当面对一个问题没有办法的时候，你能帮大家理清思路。找到问题的解决办法，具体谈谈当时情况 ", "我们在学习或者工作中面对的问题总是纷繁复杂。"]
        },
        {
            title: "生活步调",
            describe: ["有没有遇到这样的情况，当面对一个问题没有办法的时候，你能帮大家理清思路。找到问题的解决办法，具体谈谈当时情况 ", "我们在学习或者工作中面对的问题总是纷繁复杂。"]
        },
        {
            title: "输出精力",
            describe: ["有没有遇到这样的情况，当面对一个问题没有办法的时候，你能帮大家理清思路。找到问题的解决办法，具体谈谈当时情况 ", "我们在学习或者工作中面对的问题总是纷繁复杂。"]
        },
    
    ],
    result: [1, 9, 2, 0, 0, 8, 7, 0, 0],

    statement: "本报告阅读权仅限于参与测评的本人及其他经授权人士，任何组织或个人在未经许可之下，不能擅自阅读、传播、复制或以其他形式使用本报告中的任何内容。"
}


// WEBPACK FOOTER //
// ./src/views/report/config/four.js